import { ReactElement } from 'react'
import NaloxoneSurvey from '../components/survey/NaloxoneSurvey'

export const NALOXONE_SURVEY_ID_SLUG = 'NALOXONE_SURVEY'

// Direct-link path only (QR code, no sign-in). The survey is never reached from inside the portal.
function NaloxoneSurveyPage (): ReactElement {
  return <NaloxoneSurvey />
}

export default NaloxoneSurveyPage
